import React, { useState } from 'react';
import { Avatar, Modal, Tooltip } from '@shopify/polaris';
import { PersonIcon } from '@shopify/polaris-icons';

const PhotoAvatar = ({ photo, label, size = 'small' }) => {
  const [showModal, setShowModal] = useState(false);

  if (!photo) {
    return (
      <div className="flex items-center justify-center">
        <Avatar
          size={size}
          source={PersonIcon}
          name={label || 'No Photo'}
        />
      </div>
    );
  }

  // Create tooltip content with image preview
  const tooltipContent = (
    <div style={{ padding: '8px', maxWidth: '180px' }}>
      <img
        src={photo}
        alt={label || 'Preview'}
        style={{
          width: '160px',
          height: '160px',
          objectFit: 'cover',
          borderRadius: '8px',
          marginBottom: '8px'
        }}
      />
      <div style={{ textAlign: 'center' }}>
        <p style={{ fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#202223' }}>
          {label}
        </p>
        <p style={{ fontSize: '11px', color: '#6d7175' }}>
          Click to enlarge
        </p>
      </div>
    </div>
  );

  return (
    <>
      <Tooltip content={tooltipContent} preferredPosition="above" dismissOnMouseOut>
        <div
          className="inline-block cursor-pointer"
          onClick={() => setShowModal(true)}
          style={{ transition: 'transform 0.2s ease' }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          <img
            src={photo}
            alt={label || 'Staff Photo'}
            style={{
              width: size === 'small' ? '32px' : size === 'medium' ? '48px' : '64px',
              height: size === 'small' ? '32px' : size === 'medium' ? '48px' : '64px',
              borderRadius: '50%',
              objectFit: 'cover',
              border: '2px solid #e1e3e5',
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
            }}
          />
        </div>
      </Tooltip>

      {/* Full Size Modal */}
      <Modal
        open={showModal}
        onClose={() => setShowModal(false)}
        title={label || 'Photo'}
      >
        <Modal.Section>
          <div className="flex justify-center items-center p-4">
            <img
              src={photo}
              alt={label || 'Full Size'}
              className="max-w-full max-h-[70vh] object-contain rounded-lg shadow-lg"
            />
          </div>
        </Modal.Section>
      </Modal>
    </>
  );
};

export default PhotoAvatar;
